export const urlRoutes={
    public:{
     home:"/",
     login:"/login"
    },
    private:{
     dashboard:"/dashboard",
     buildingOccupancy:"/building-occupancy",
     missingPeople:"/missing-people",
     combinedData:"/combined-data",
     monthlyReport:"/monthly-report",
     floorVise:"/floor-wise",
     heatMap:"/heat-map",
     anpr:"/anpr-report",
     foodViseReport:"/food-wise-report",
     analytics:"/analytics",
     specialArea:"/special-area",
     escalation:"/escalation",
     liveAttendance:"/live-attendance",
     liveStream:"/live-stream",
     fr:"/fr",
     frInOut:"/in-out",
     attendance:"/attendance",
     employeeAttendanceDetails:"/employee-attendance-details/:employeeId/:date",
     fashion:"/fashion",
     role:"/role",
     user:"/user",
     vehicle:"/vehicle",
     notifications:"/notifications/:type",
     dailyWiseReport:"/daily-wise-report",
     monthWiseReport:"/monthly-wise-report"
    }
} 